import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import { ExternalLink, LinkedLogo, NamedLink } from '../../components';
import Icons from '../../components/Icons/Icons';
import { AUCTIONS_SEARCH_PARAMS, createSearchPageTo } from '../../util/search';

import css from './FooterContainer.module.css';

function FooterContainer({}) {
  const marketplaceLinks = [
    {
      name: 'SearchPage',
      textId: 'TopbarDesktop.nav.buyNow',
      to: createSearchPageTo(),
    },
    {
      name: 'SearchPage',
      textId: 'TopbarDesktop.nav.auctions',
      to: createSearchPageTo(AUCTIONS_SEARCH_PARAMS),
    },
    { name: 'SearchPage', textId: 'Footer.marketplace.browseBarrels' },
    { name: 'LandingPage', textId: 'Footer.marketplace.distilleries' },
  ];
  const supportLinks = [
    {
      name: 'LandingPage',
      textId: 'Footer.support.faqs',
      to: { hash: '#faq' },
    },
    {
      name: 'ContactPage',
      textId: 'TopbarDesktop.nav.contactUs',
    },
  ];
  const companyLinks = [
    { name: 'AboutUsPage', textId: 'TopbarDesktop.nav.about' },
    {
      name: 'PrivacyPolicyPage',
      textId: 'AuthenticationPage.termsAndConditionsPrivacyLinkText',
    },
    {
      name: 'TermsOfServicePage',
      textId: 'AuthenticationPage.termsAndConditionsTermsLinkText',
    },
  ];
  const socialLinks = [
    {
      href: 'https://www.instagram.com/ChevalierCasks/',
      icon: 'instagram',
      label: 'Instagram',
    },
    {
      href: 'https://www.facebook.com/people/Chevalier-Casks/100090551916172/',
      icon: 'facebook',
      label: 'Facebook',
    },
    {
      href: 'http://linkedin.com/company/chevalier-casks',
      icon: 'linkedin',
      label: 'LinkedIn',
    },
  ];

  return (
    <div className={css.footer}>
      <div className={css.footerTop}>
        <div className={css.contentWidth}>
          <div className={css.leftBlock}>
            <div className={css.linksBlock}>
              <LinkedLogo />
              <p>
                <FormattedMessage id="Footer.tagline" />
              </p>
            </div>
          </div>
          <div className={css.rightBlock}>
            <FooterLinksBlock titleId="Footer.title.marketplace" links={marketplaceLinks} />
            <FooterLinksBlock titleId="Footer.title.support" links={supportLinks} />
            <FooterLinksBlock titleId="Footer.title.company" links={companyLinks} />
          </div>
        </div>
      </div>

      <div className={css.footerBottom}>
        <div className={css.contentWidth}>
          <div className={css.footerBottomLeft}>
            <p>© 2026 Chevalier Casks. All rights reserved.</p>
          </div>
          <div className={css.footerBottomRight}>
            <div className={css.socialLinks}>
              {socialLinks.map(link => (
                <ExternalLink
                  key={link.icon}
                  href={link.href}
                  className={css.link}
                  aria-label={link.label}
                >
                  <Icons name={link.icon} />
                </ExternalLink>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
function FooterLinksBlock({ titleId, links }) {
  return (
    <div className={css.linksBlock}>
      <h2>
        <FormattedMessage id={titleId} />
      </h2>
      {links.map((link, index) =>
        link?.external ? (
          <ExternalLink key={index} href={link.href} className={css.link}>
            <FormattedMessage id={link.textId} />
          </ExternalLink>
        ) : (
          <NamedLink
            key={index}
            className={css.link}
            name={link.name}
            params={link.params}
            to={link.to || {}}
          >
            <FormattedMessage id={link.textId} />
          </NamedLink>
        )
      )}
    </div>
  );
}
export default FooterContainer;
